import { createBrowserMonitor, listenForOwnedErrors } from '@prismancy/shared/monitoring';

const isExtension = typeof location !== 'undefined' && location.protocol === 'chrome-extension:';
export const extensionMonitor = createBrowserMonitor({
  dsn: isExtension ? import.meta.env.VITE_GLITCHTIP_DSN : import.meta.env.VITE_GLITCHTIP_WEB_DSN,
  service: isExtension ? 'extension' : 'web-app',
  environment: import.meta.env.VITE_GLITCHTIP_ENVIRONMENT || import.meta.env.MODE,
  release: import.meta.env.VITE_GLITCHTIP_RELEASE || import.meta.env.VITE_BUILD_NUMBER,
});

if (typeof window !== 'undefined') {
  listenForOwnedErrors(extensionMonitor, window, window.location.origin);
} else if (typeof self !== 'undefined') {
  listenForOwnedErrors(extensionMonitor, self, self.location.href);
}
